import HomeInsightsSection from './HomeInsightsSection'

export default HomeInsightsSection
